import { render, staticRenderFns } from "./SoalProcess.vue?vue&type=template&id=84843194&scoped=true"
import script from "./SoalProcess.vue?vue&type=script&lang=js"
export * from "./SoalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84843194",
  null
  
)

export default component.exports